function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
import apiCall from './apiCall';
import { fetchTranslations, updateMessages } from './actions';
import { Map } from 'immutable';
var changesEventSource = null;
var Engine = /*#__PURE__*/
function () {
  function Engine(config, dispatch) {
    var currentLocation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '/';
    _classCallCheck(this, Engine);
    this.currentLocation = currentLocation;
    this.config = config;
    this.dispatch = dispatch;
    this.apiCall = apiCall;
    this.__listenOnTranslationServer();
    this.translationStore = Map();
    this.previousTranslationsSend = this.translationStore;
    this.sendTimeout = null;
  }
  _createClass(Engine, [{
    key: "updateLocation",
    value: function updateLocation(location) {
      this.currentLocation = location;
      this.__enqueeSendTranslations();
    }
  }, {
    key: "rememberUsedTranslation",
    value: function rememberUsedTranslation(locale, path, message) {
      var _this = this;
      this.locale = locale;
      if (!this.config.synchronize) return;
      this.__enqueeSendTranslations();
      var keys = path ? [locale].concat(path) : locale;
      if (this.__dataType(message) === 'array') message.map(function (v, k) {
        return _this.rememberUsedTranslation(keys.concat([k]), null, v);
      });else this.__rememberTranslation(keys, message);
    }
  }, {
    key: "sendTranslations",
    value: function sendTranslations() {
      var _this2 = this;
      if (!this.config.synchronize) return;
      if (this.translationStore === this.previousTranslationsSend) return;
      this.translationStore.reduce(function (output, translations, location) {
        return output.set(location, translations.filter(function (_, key) {
          return !_this2.previousTranslationsSend.getIn([location, key]);
        }));
      }, Map()).filter(function (translations) {
        return !translations.isEmpty();
      }).map(function (translations, location) {
        return _this2.apiCall(_this2.config, 'post', 'translations', {
          location: location,
          locale: _this2.locale,
          translations: translations.toIndexedSeq().toJS()
        });
      });
      this.previousTranslationsSend = this.translationStore;
    }
  }, {
    key: "__enqueeSendTranslations",
    value: function __enqueeSendTranslations() {
      if (!this.config.synchronize) return;
      if (this.sendTimeout) {
        clearTimeout(this.sendTimeout);
        this.sendTimeout = null;
      }
      this.sendTimeout = setTimeout(this.sendTranslations.bind(this), 1000);
    }
  }, {
    key: "__rememberTranslation",
    value: function __rememberTranslation(keys, message) {
      var path = keys.join('.');
      this.translationStore = this.translationStore.mergeIn([this.currentLocation, path], {
        data_type: this.__dataType(message),
        key: path,
        text: message
      });
    }
  }, {
    key: "__listenOnTranslationServer",
    value: function __listenOnTranslationServer() {
      var _this3 = this;
      var _this$config = this.config,
        apiUrl = _this$config.apiUrl,
        apiToken = _this$config.apiToken,
        synchronize = _this$config.synchronize;
      if (typeof window !== 'undefined' && !changesEventSource && synchronize) {
        this.dispatch(fetchTranslations(this.config));
        if (!this.config.disableEventSource) {
          var EventSource = require('eventsource');
          changesEventSource = new EventSource("".concat(apiUrl, "/changes?token=").concat(apiToken));
          changesEventSource.addEventListener('translations_changed', function (_ref) {
            var data = _ref.data;
            _this3.dispatch(updateMessages(JSON.parse(data)));
          });
        }
      }
    }
  }, {
    key: "__dataType",
    value: function __dataType(value) {
      if (!value && value !== 0) return null;
      switch (_typeof(value)) {
        case 'object':
          return 'array';
        case 'string':
          return 'string';
        case 'number':
          return 'float';
        default:
          return null;
      }
    }
  }]);
  return Engine;
}();
export { Engine as default };